import { ehDeciduo, parseDentes } from "@bookdental/schemas";
import { Arcada } from "./Arcada";

/** Dentes de um item já salvo: a arcada permanente se houver permanente, a decídua se houver decíduo
 *  (as duas lado a lado na dentição mista). Texto livre sem dente reconhecido vira só o texto. */
export function ArcadaSomenteLeitura({
  dentes,
  largura = 180,
}: {
  dentes: string | null | undefined;
  largura?: number;
}) {
  const lista = parseDentes(dentes);
  if (lista.length === 0) return <p className="text-sm text-zinc-700 dark:text-foreground/80">{dentes || "—"}</p>;
  const temDeciduo = lista.some(ehDeciduo);
  const temPermanente = lista.some((d) => !ehDeciduo(d));
  return (
    <div className="flex flex-wrap gap-3">
      {temPermanente && (
        <div className="w-full" style={{ maxWidth: largura }}>
          <Arcada denticao="permanente" selecionados={lista} somenteLeitura />
        </div>
      )}
      {temDeciduo && (
        <div className="w-full" style={{ maxWidth: largura }}>
          <Arcada denticao="decidua" selecionados={lista} somenteLeitura />
        </div>
      )}
    </div>
  );
}
